const pageNameKey = "tile";

export const tileEn = {
  [pageNameKey]: {
    id: "Id: ",
    title: "Title: ",
    position: "Position: ",
    edit: "edit",
    delete: "delete",
  },
};

export const tilePtBr = {
  [pageNameKey]: {
    id: "ID: ",
    title: "Título: ",
    position: "Cargo: ",
    edit: "Editar",
    delete: "Excluir",
  },
};

export const tileDe = {
  [pageNameKey]: {
    id: "Id: ",
    title: "Titel: ",
    position: "Position: ",
    edit: "bearbeiten",
    delete: "löschen",
  },
};

export const tileZhHans = {
  [pageNameKey]: {
    id: "Id: ",
    title: "标题: ",
    position: "位置: ",
    edit: "编辑",
    delete: "删除",
  },
};

export const tileIt = {
  [pageNameKey]: {
    id: "Id: ",
    title: "Titolo: ",
    position: "Posizione: ",
    edit: "modifica",
    delete: "cancella",
  },
};

export const tileEs = {
  [pageNameKey]: {
    id: "Id: ",
    title: "Título: ",
    position: "Cargo: ",
    edit: "editar",
    delete: "eliminar",
  },
};

export const tileNl = {
  [pageNameKey]: {
    delete: "verwijderen",
    edit: "bewerken",
    id: "ID: ",
    position: "Positie: ",
    title: "Titel: ",
  },
};

export const tileTr = {
  [pageNameKey]: {
    delete: "silmek",
    edit: "düzenlemek",
    id: "İD:",
    position: "Konum:",
    title: "Başlık:",
  },
};
